<div
  class="main flex items-center"
  [ngClass]="{
    checked: checked$ | async,
    'stay-open': hasContextMenuOpen,
    'padding-right': hasPaddingRight
  }"
  (contextmenu)="onContextMenu($event, track)"
  (click)="onSelectClickLine($event)"
  [rkDndDraggable]="track"
  dndEffectAllowed="copy"
  [dndDragImageOffsetFunction]="dndDragImageOffsetFunction"
  [dndType]="getType()"
  [class.locked]="linePlanLocked"
  [dndDisableIf]="linePlanLocked"
>
  <figure>
    <img [src]="track.cover" />
    <div class="button-overlay">
      <mat-checkbox (change)="selectLine()" [checked]="checked$ | async"></mat-checkbox>
    </div>
  </figure>

  <div class="title elipsis">
    <span class="elipsis"> {{ track.title }} </span>
    <div class="title-buttons">
      <rk-icon-button
        [bordered]="true"
        [faIcon]="isLoaded && isPlaying ? 'fa-pause' : 'fa-play'"
        class="mr-1"
        [size]="23"
        [style]="{ width: '29px', height: '29px' }"
        (click)="playTrack(_track)"
      >
      </rk-icon-button>
      <rk-icon-button
        [bordered]="true"
        *ngIf="!track.locked"
        [faIcon]="'fa-pen'"
        class="mr-1"
        [size]="23"
        [style]="{ width: '29px', height: '29px' }"
        (click)="editTrack.emit(track)"
      >
      </rk-icon-button>
      <rk-icon-button
        [bordered]="true"
        [svgIcon]="'dot-down'"
        [size]="23"
        [style]="{ width: '29px', height: '29px' }"
        (click)="onContextMenu($event, track)"
      >
      </rk-icon-button>
    </div>
  </div>
  <div class="artist elipsis">{{ track.artist }}</div>
  <div class="album elipsis" *ngIf="columns.album">{{ track.album }}</div>
  <div class="year" *ngIf="!isChronic && columns.year">{{ track.year }}</div>
  <div class="added" *ngIf="!isChronic && columns.addedDate">
    {{ track.uploadDate | localizedDate : 'shortDate' }}
  </div>
  <div #playlistRef class="playlists" *ngIf="columns.playlists">
    <div
      class="playlist"
      *ngFor="let playlist of track.playlists.slice(0, tagDisplayedLimiter)"
      (click)="openPlaylist(playlist.id)"
    >
      <div class="playlist-icon">
        <rk-playlist-icon [playlist]="playlist"></rk-playlist-icon>
      </div>
      <span class="playlist-text">{{ playlist.name }}</span>
    </div>
    <rk-color-chip
      *ngIf="track.playlists.length > tagDisplayedLimiter"
      class="more-playlists"
      [color]="'#9c9c9c'"
      [name]="'+' + track.playlists.slice(tagDisplayedLimiter).length"
      [ellipsis]="false"
      [mini]="true"
      [matMenuTriggerFor]="playlistList"
    >
    </rk-color-chip>
  </div>
  <div #tagRef class="tags" *ngIf="!isChronic && columns.tags">
    <rk-color-chip
      class="mr-1 tag-chip"
      *ngFor="let tag of track.tags.slice(0, tagDisplayedLimiter)"
      [name]="tag.name"
      [color]="tag.color"
      (click)="openTag(tag.id)"
    ></rk-color-chip>
    <rk-color-chip
      *ngIf="track.tags.length > tagDisplayedLimiter"
      class="more-tags"
      [color]="'#9c9c9c'"
      [name]="'+' + track.tags.slice(tagDisplayedLimiter).length"
      [ellipsis]="false"
      [mini]="true"
      [matMenuTriggerFor]="tagList"
    >
    </rk-color-chip>
  </div>
  <div class="duration" *ngIf="columns.duration">
    {{ track.timeSeconds ? (track.timeSeconds | timeFormat) : '' }}
  </div>
  <div class="bpm" *ngIf="!isChronic && columns.bpm">
    {{ track.bpm }}
  </div>
  <div class="kbps" *ngIf="!isChronic && columns.kbps">
    {{ track.bitrate }}
  </div>

  <div rkDragImageRef class="drag-style">
    <ng-container *ngIf="checked$ | async; else notChecked">
      <span>{{
        'MEDIA.ACTIONS.DRAG_PREVIEW_COUNT'
          | translate : { tracks: numberCheckedTracks$ | async }
      }}</span>
    </ng-container>
    <ng-template #notChecked>
      <span class="bigger" [ngClass]="{ 'no-artist': !track.artist }">{{
        track.title
      }}</span>
      <span *ngIf="track.artist"> - {{ track.artist }}</span>
    </ng-template>
  </div>
</div>
<mat-menu
  #tagList="matMenu"
  [overlapTrigger]="false"
  class="tag-menu"
  backdropClass="tag-menu"
>
  <div class="tag-list">
    <rk-color-chip
      class="mr-1"
      *ngFor="let tag of track.tags.slice(tagDisplayedLimiter)"
      [name]="tag.name"
      [color]="tag.color"
      [onFlexed]="true"
      (click)="openTag(tag.id)"
    ></rk-color-chip>
  </div>
</mat-menu>

<mat-menu
  #playlistList="matMenu"
  [overlapTrigger]="false"
  class="tag-menu"
  backdropClass="tag-menu"
>
  <div class="playlist-list">
    <div
      class="playlist"
      *ngFor="let playlist of track.playlists.slice(tagDisplayedLimiter)"
      (click)="openPlaylist(playlist.id)"
    >
      <div class="playlist-icon">
        <rk-playlist-icon [playlist]="playlist"></rk-playlist-icon>
      </div>
      <span class="playlist-text">{{ playlist.name }}</span>
    </div>
  </div>
</mat-menu>
